<template>
  <button
    class="passenger-selection-row m-0 p-0 btn btn-ghost"
    @click="
      () => {
        if (onClick) onClick();
      }
    "
    v-b-hover="handleHover"
  >
    <vb-icon
      v-if="is_infant(passenger)"
      name="infant"
      :size="18"
      :color="sass('primary')"
    ></vb-icon>
    <span v-else class="thin">P{{ passenger.id }}</span>
    <span
      :class="
        'text-nowrap font-size-16px ' +
        (isHovered ? 'text-primary' : '') +
        (selected ? 'text-primary semibold' : '')
      "
      >{{ formatPassengerName(passenger) }}</span
    >
    <span
      class="overflow-hidden truncate-text-overflow passenger-selection-grow"
    >
      <span class="thin">
        <span v-if="is_infant(passenger)" class="text-nowrap">NEONATO</span>
        <span v-else-if="is_child(passenger)" class="text-nowrap">BAMBINO</span>
        <span v-if="passenger.holding" class="text-nowrap semibold">con neonato</span>
      </span>
    </span>
    <span
      v-if="seat"
      class="text-primary semibold passenger-selection-row-seat"
      >{{ seat.number }}</span
    >
    <span
      v-else-if="is_infant(passenger)"
      class="text-primary semibold passenger-selection-row-seat"
      >Neonato in braccio</span
    >
    <span v-else-if="emptyNotSelected"></span>
    <span v-else class="text-gray semibold passenger-selection-row-seat"
      >Scelta della compagnia</span
    >
  </button>
</template>

<script>
import { formatPassengerName } from "@liveflight/utilities/mixins";
import { is_infant, is_child } from "@liveflight/utilities";

export default {
  name: "passenger-selection-row",
  props: {
    passenger: Object,
    seat: Object,
    emptyNotSelected: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },
  data() {
    return {
      formatPassengerName,
      isHovered: false,
    };
  },
  methods: {
    is_infant,
    is_child,
    handleHover() {
      if (this.onClick) {
        this.isHovered = !this.selected && !this.isHovered;
      }
    },
  },
};
</script>

<style class="scss">
.passenger-selection-row {
  display: flex;
  gap: 10px;

  .passenger-selection-grow {
    text-align: start;
    flex-grow: 1;
  }

  .passenger-selection-row-seat {
    text-align: end;
  }

  span:last-of-type {
    margin-left: auto;
  }
}
</style>
